import * as tslib_1 from "tslib";
import * as couponReferenceActions from './store/Actions';
export var couponActions = tslib_1.__assign({}, couponReferenceActions);
